<template>
  <div class="section" :class="main_color">
    <div class="page-content">
      <div class="part">
        <div class="lexique">
          <div class="titre-2">Dynamisme de la construction locative</div>
          <div class="source">
            Sources : ADEQUATION &ndash; INSEE {{lexiqueParam.sociodemo_annee_max_demographie}}
          </div>
          <div class="lex-content">
            <p>
              <span class="title">Dynamisme de la construction locative libre :</span> il s&rsquo;agit
              d&rsquo;un ratio de livraisons de logements locatifs neufs pour
              1.000 habitants mis en place par ADEQUATION pour appr&eacute;cier
              les tensions &agrave; venir sur le march&eacute; locatif local.
            </p>
          </div>
          <div class="titre-2">Quartier d&rsquo;appartenance du projet</div>
          <div class="source">
            Sources : ADEQUATION &ndash; sites spécialisés
          </div>
          <div class="lex-content">
            <p>
              Les loyers pratiqu&eacute;s localement sont indiqu&eacute;s hors
              stationnement (hors stat.) pour le collectif et avec stationnement
              (avec stat.) pour l&rsquo;individuel.
            </p>
          </div>
          <div class="lex-content">
            <p>
              <span class="title"> Changement zonage* :</span> Commune qui a vu son zonage Pinel évolué 
              au regard de l&rsquo;arr&ecirc;t&eacute; minist&eacute;riel du 2 octobre 2023.
            </p>
          </div>

          <el-checkbox
            v-if="editor.mode === 'editing'"
            :parent_data="active_study.etudeData.lexique"
            property="show_budget"
            label="Afficher les informations concernant le budget des ménages cibles en LLI"
            :editable="true"
            class="q-mt-md"
          />

          <div v-if="active_study.etudeData.lexique.show_budget">
            <div class="titre-1">Budget des m&eacute;nages cibles en LLI</div>
            <div class="source">
              Sources : INSEE FILOSOFI {{lexiqueParam.budget_annee}}
            </div>
            <div class="lex-content">
              <p>
                Les revenus des m&eacute;nages sont r&eacute;partis en dix
                cat&eacute;gories (les d&eacute;ciles). La cible principale du LLI
                correspond aux m&eacute;nages dont les revenus sont ceux des {{decileLabel}} soit 30% des m&eacute;nages. Sur la base de ces revenus
                maximums est calcul&eacute; un loyer maximum admissible hors
                charges et hors stationnement (25% du revenu).<br />Les
                hypoth&egrave;ses retenues dans cette analyse :
              </p>
              <ul>
                <li>
                  Les besoins des m&eacute;nages (T2, T3, etc.) sont li&eacute;s
                  &agrave; la composition familiale.
                </li>
                <li>
                  Le revenu augmente g&eacute;n&eacute;ralement avec la
                  composition familiale (ce n'est pas l'arriv&eacute;e d'un enfant
                  qui fait &eacute;voluer le revenu, mais plut&ocirc;t l'&acirc;ge
                  moyen)
                </li>
                <li>
                  Le loyer maximal admissible est &eacute;quivalent &agrave; 25%
                  du revenu (ce qui m&egrave;ne &agrave; environ 30% avec les
                  charges - en moyenne entre 10 et 12% du loyer dans le neuf).
                </li>
              </ul>
              <p>
                Les loyers pratiqu&eacute;s localement correspondent aux loyers
                indiqu&eacute;s dans le tableau &laquo;&nbsp;quartier
                d&rsquo;appartenance du projet&nbsp;&raquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-lexique2",
	mixins: [PageMixin],
  
	props: {
		main_color: { default: "gray" },
	},
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters(["active_study", "editor"]),
		lexiqueParam (){
			return this.active_study.qlikData.parameters.lexiqueParam;
		},
		decileLabel (){
			return this.active_study.etudeData.budget_menages.decile_label;
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';
@import '../../../../../assets/css/lexique';
</style>
